import { Article } from '@/shared/components/article';
import ThunderstormIcon from '@/shared/components/icons/thunderstorm-icon';
import { TeamImages } from './team-images';
export const AboutTeam = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Teachers</h2>
      <div className="grid grid-cols-1 items-center gap-x-5 gap-y-14 md:grid-cols-2 md:gap-x-10">
        <ul className="mx-auto max-w-sm space-y-5 sm:mx-0 sm:max-w-xl">
          <li className="flex items-center gap-2">
            <ThunderstormIcon className="mr-2 h-6 w-6 shrink-0 text-brand-accent-light sm:mr-4" />
            <span className="text-base lg:text-lg">
              Proficient in&nbsp;English at&nbsp;C1&nbsp;level or&nbsp;higher
            </span>
          </li>

          <li className="flex items-center gap-2">
            <ThunderstormIcon className="mr-2 h-6 w-6 shrink-0 text-brand-accent-light sm:mr-4" />
            <span className="text-base lg:text-lg">
              Experienced in&nbsp;teaching Business English for various industries (law, IT, manufacturing, tourism,
              career consulting, and more)
            </span>
          </li>

          <li className="flex items-center gap-2">
            <ThunderstormIcon className="mr-2 h-6 w-6 shrink-0 text-brand-accent-light sm:mr-4" />
            <span className="text-base lg:text-lg">
              Experienced teachers with expertise in&nbsp;IT and recruitment are ready to&nbsp;help you achieve your
              most ambitious goals!
            </span>
          </li>
        </ul>

        <TeamImages />
      </div>
    </Article>;
};